
import React, { useEffect } from 'react';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container, ThemeProvider } from '@mui/system';

import userSlice from './features/userSlice';
import productsSlice from './features/productsSlice';
import prductInCartSlice from './features/productInCartSlice';
import categoriesSlice from './features/categoriesSlice';
import ordersSlice from './features/ordersSlice';
import contactSlice from './features/contactSlice';
import searchSlice from './features/searchSlice';
import customersReducer from './features/costumerSlice';
import favoritesReducer from './features/favoritesSlice';


import ForgotPassword from './components/ForgotPassword';
import HomePage from './components/homePage';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import Cart from './components/cart';
import Products from './components/products';
import Categories from './components/categories';
import Order from './components/order';
import ContactForm from './components/contactForm';
import AboutUs from './components/AboutUs';
import Payment from './components/Payment';
import Checkout from './components/oldComponent/checkoutPage';
import OrderConfirmation from './components/OrderConfirmation';


import theme from "./styles/themeStyle";
import themeAdmin from "./styles/adminTheme";
import AdminApp from './components/adminComponents/AdminApp';
import Dashboard from './components/adminComponents/Dashboard';
import AdminProducts from './components/adminComponents/products/AdminProducts';
import Settings from './components/adminComponents/Settings';
import ProductManagement from './components/ProductManagement';
import OrderManagement from './components/OrderManagement';
import Conditions from './components/Conditions';
import MessagesList from './components/adminComponents/MessagesList';
import FavoritesList from './components/Favorites';
import CustomersList from './components/adminComponents/CustomersList';
import MyOrders from './components/MyOrders';
import AdminCategories from './components/adminComponents/AdminCategories';
import ProductsBySubcategory from './components/ProductsBySubcategory';
import CompletedOrders from './components/adminComponents/CompletedOrders';
import CheckoutSummary from './components/CheckoutSummary';
import AdminRoute from "./components/AdminRoute";

import ResetPassword from './components/ResetPassword';
import AdminHomeBanners from './components/adminComponents/AdminHomeBanners';
import ShippingPolicy from "./components/ShippingPolicy";
import AccessibilityStatement from "./components/AccessibilityStatement";


const myStore = configureStore({
  reducer: {
    user: userSlice,
    product: productsSlice,
    cart: prductInCartSlice,
    categries: categoriesSlice,
    orders: ordersSlice,
    contact: contactSlice,
    search: searchSlice,
    customers: customersReducer,
    favorites: favoritesReducer,


  }
})

function App() {
  useEffect(() => {
    document.title = "שיינ'ס סטוק";
  }, []);

  return (
    <Provider store={myStore}>
      <ThemeProvider theme={theme} >
        <Container maxWidth="xl" sx={{ background: '#fff' }}>
          <Router>
            <Routes>

              <Route path="/" element={<HomePage />}>

                <Route path="/signIn" element={<SignIn />} />
                <Route path="/signUp" element={<SignUp />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
                <Route path="/reset-password/:token" element={<ResetPassword />} />


                <Route path="/about" element={<AboutUs />} />
                <Route path="/payment" element={<Payment />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/checkoutSummary" element={<CheckoutSummary />} />
                <Route path="/favorite" element={<FavoritesList />} />
                <Route path="/my-orders" element={<MyOrders />} />

                <Route path="/cart" element={<Cart />} />
                <Route path="/" element={<Categories />} />
                <Route path="/products" element={<Products />} />
                <Route path="/order" element={<Order />} />
                <Route path="/contact" element={<ContactForm />} />
                <Route path="/conditions" element={<Conditions />} />
                <Route path="/orderConfirmation" element={<OrderConfirmation />} />
                <Route path="/products/sub/:subId" element={<ProductsBySubcategory />} />
                <Route path="/shipping-policy" element={<ShippingPolicy />} />
                <Route path="/accessibility-statement" element={<AccessibilityStatement />} />
              </Route>

              <Route path="/admin" element={<AdminRoute> <AdminApp /> </AdminRoute>}>

                <Route path="dashboard" element={<Dashboard />} />

                <Route path="home-banners" element={<AdminHomeBanners />} />
                <Route path="/admin/completed-orders" element={<CompletedOrders />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path='message' element={<MessagesList />} />
                <Route path='customers' element={<CustomersList />} />
                <Route path="categories" element={<AdminCategories />} />

                <Route path="settings" element={<Settings />} />
                <Route path="manage-products" element={<ProductManagement />} />
                <Route path="manage-orders" element={<OrderManagement />} />
              </Route>
            </Routes>
          </Router>
        </Container>
      </ThemeProvider>

    </Provider>
  );
}

export default App;




// import React from 'react';
// import { configureStore } from '@reduxjs/toolkit';
// import { Provider } from 'react-redux';
// import userSlice from './features/userSlice';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import HomePage from './components/homePage';
// import SignIn from './components/SignIn';
// import SignUp from './components/SignUp';
// import Cart from './components/cart'
// import Header from './components/header';
// import Products from './components/products';
// import productsSlice from './features/productsSlice';
// import prductInCartSlice from './features/productInCartSlice';
// import { Container, Typography, Box, Stack, Grid, Button } from "@mui/material";
// import { ThemeProvider } from '@mui/material/styles';
// import theme from "./styles/themeStyle";
// import { useEffect } from "react";
// import Categories from './components/categories';
// import categoriesSlice from './features/categoriesSlice';
// import Order from './components/order';
// import ordersSlice from './features/ordersSlice';
// import contactSlice from './features/contactSlice';
// import ContactForm from './components/contactForm';
// // import Search from './components/Search';
// import searchSlice from './features/searchSlice';
// import AboutUs from './components/AboutUs';
// import Payment from './components/Payment';
// import themeAdmin from './styles/adminTheme';
// import AdminApp from './components/adminComponents/AdminApp';
// import Dashboard from './components/adminComponents/Dashboard';
// import AdminProducts from './components/adminComponents/AdminProducts';
// import Settings from './components/adminComponents/Settings';



// const myStore = configureStore({
//   reducer: {
//     user: userSlice,
//     product: productsSlice,
//     cart: prductInCartSlice,
//     categries: categoriesSlice,
//     orders: ordersSlice,
//     contact: contactSlice,
//     search: searchSlice,
//     // cart2: cartSlice,
//   }
// })

// function App() {
//   useEffect(() => {
//     document.title = "שיינ'ס סטוק";
//   }, []);
//   //12

//   // const isAdmin = true; // זה צריך להיות מבוסס על לוגיקה בפועל, למשל אימות המשתמש


//   return (
//     <Provider store={myStore}>
//       {/* <ThemeProvider theme={isAdmin ? themeAdmin :theme}> */}
//       <ThemeProvider theme={theme}>
//         <Container maxWidth="xl" sx={{ background: '#fff' }}>
//            <Router>
//           {/* <Routes >
//           <Route  path='/admin' element={<AdminApp/>}/>
//           <Route  path='/dashboard' element={<Dashboard/>}/>
//           <Route  path='/adminProducts' element={<AdminProducts/>}/>
//           <Route  path='/setting' element={<Settings/>}/>
//           </Routes> */}

//           <Routes>
//               <Route path="/signIn" element={<SignIn />} />
//               <Route path="/signUp" element={<SignUp />} />
//               <Route path="/" element={<HomePage />}>
//                 <Route path="/about" element={<AboutUs />} />
//                 <Route path="/payment" element={<Payment />} />
//                 <Route path="/cart" element={<Cart />} />
//                 <Route path="/" element={<Categories />} />
//                 <Route path="/products" element={<Products />} />
//                 <Route path="/order" element={<Order />} />
//                 <Route path="/contact" element={<ContactForm />} />
//                 {/* <Route path="/search" component={<Search/>} /> */}
//                 {/* <Route path='/categories' element={<Categories/>}/> */}
//                 {/* <Route path="/Registration" element={<RegistrationForm/>} /> */}
//                 <Route />
//               </Route>
//             </Routes>
//           </Router>
//         </Container>
//       </ThemeProvider>
//     </Provider>
//   );
// }

// export default App;
